// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xl_a bhj_uj bhj_ua bhj_vx bhj_qk bhj_sl bhj_qb"};